<script setup>
import { PopoverTrigger, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: undefined },
  as: { type: [String, Object], default: undefined },
});

const forwardedProps = useForwardProps(props);
</script>

<template>
  <PopoverTrigger v-bind="forwardedProps" data-slot="popover-trigger">
    <slot />
  </PopoverTrigger>
</template>
